import { FunctionComponent } from "react";

import { List } from "../../schema/list";
import { FieldMappingCard } from "./FieldMappingCard";
import { ProvidedFileCard } from "./ProvidedFileCard";

export interface DownloadSourceProps {
	list: List;
}

/**
 * Review step for a list whose source was scraped for the user: the provided file plus the field
 * mapping that decides what gets enriched from it.
 */
export const DownloadSource: FunctionComponent<DownloadSourceProps> = ({ list }) => {
	return (
		<div className="flex flex-col gap-6">
			<ProvidedFileCard list={list} />
			<FieldMappingCard list={list} />
		</div>
	);
};
